// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { addFilesToCatalogAgentThread } from "./schema/catalog-agent/add-files-to-catalog-agent-thread";
import { confirmCatalogAgentTool } from "./schema/catalog-agent/confirm-catalog-agent-tool";
import { getCatalogAgentOperationDiff } from "./schema/catalog-agent/get-catalog-agent-operation-diff";
import { getCatalogAgentThread } from "./schema/catalog-agent/get-catalog-agent-thread";
import { streamCatalogAgent } from "./schema/catalog-agent/stream-catalog-agent";
import { undoCatalogAgentOperation } from "./schema/catalog-agent/undo-catalog-agent-operation";
import { uploadCatalogAgentFile } from "./schema/catalog-agent/upload-catalog-agent-file";

export const groupJ: {
  addFilesToCatalogAgentThread: typeof addFilesToCatalogAgentThread;
  streamCatalogAgent: typeof streamCatalogAgent;
  uploadCatalogAgentFile: typeof uploadCatalogAgentFile;
  confirmCatalogAgentTool: typeof confirmCatalogAgentTool;
  getCatalogAgentThread: typeof getCatalogAgentThread;
  getCatalogAgentOperationDiff: typeof getCatalogAgentOperationDiff;
  undoCatalogAgentOperation: typeof undoCatalogAgentOperation;
} = {
  addFilesToCatalogAgentThread,
  streamCatalogAgent,
  uploadCatalogAgentFile,
  confirmCatalogAgentTool,
  getCatalogAgentThread,
  getCatalogAgentOperationDiff,
  undoCatalogAgentOperation,
};
